import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import MyButton from './buttons'
import { ScreenMode, ScreenModeType } from '../pages/LoginRegisterPages'
import { Link } from 'react-router-dom'

interface StatusSelectionProps {
  status: string
  handleStatusChange: (status: string) => void
  onSwitchMode: (mode: ScreenModeType) => void
  setStatusSelected: (selected: boolean) => void
  isFullScreen: boolean
  setIsFullScreen: (fullScreen: boolean) => void
}

const StatusSelection: React.FC<StatusSelectionProps> = ({
  status,
  handleStatusChange,
  onSwitchMode,
  setStatusSelected,
  isFullScreen,
  setIsFullScreen,
}) => {
  const { t } = useTranslation()
  useEffect(() => {
    const isMobile = window.innerWidth < 768 // Si < 768px, c'est mobile
    if (isMobile) {
      setIsFullScreen(true) // ✅ Active le mode plein écran automatiquement
    }
  }, [])
  const statusOption = (value: string, title: string, description: string) => (
    <label
      className={`p-4 md:p-5 rounded-lg flex justify-center mb-3 cursor-pointer font-semibold transition-all
        ${
          status === value
            ? 'bg-redpink text-white'
            : 'bg-grisclair text-anthracite hover:text-white hover:bg-redpink'
        }`}
      onClick={() => handleStatusChange(value)}
    >
      <div>
        <span className='block md:inline'>{title}</span>
        <span className='text-sm block font-normal mt-1 md:mt-0'>
          {description}
        </span>
      </div>
    </label>
  )

  return (
    <div
      className={`${
        isFullScreen
          ? 'fixed inset-0 bg-white z-50 flex flex-col justify-center px-6'
          : 'w-full px-4 md:px-8 max-w-2xl mx-auto'
      }`}
    >
      <div className='space-y-4'>
        <div className='w-full'>
          <div className='flex flex-col w-full'>
            {statusOption(
              'private, escort, massage',
              t('private-massage-escort'),
              t('private-massage-escort-desc'),
            )}
            {statusOption(
              'maison privee, bars et clubs prive, salons de massage, hotels coquins, saunas prives, clubs echangistes, event',
              t('establishment-status'),
              t('establishment-status-desc'),
            )}
            {statusOption(
              'libertins ou visiteur',
              t('libertine-visitor-status'),
              t('libertine-visitor-status-desc'),
            )}
          </div>
        </div>

        <div className='flex flex-col sm:flex-row justify-between gap-4 mt-6'>
          <Link to='/login'>
            <MyButton
              variant='anthracite'
              className='w-full sm:w-auto text-base py-3 rounded'
            >
              {t('back-to-login')}
            </MyButton>
          </Link>
          <MyButton
            variant='green'
            className={`
              w-full 
              sm:w-auto 
              py-3.5 
              rounded-lg 
              transition-all 
              duration-200
              ${
                !status
                  ? 'opacity-50 cursor-not-allowed'
                  : 'hover:shadow-lg hover:scale-[1.02]'
              }
            `}
            onClick={() => {
              setStatusSelected(true)
            }}
            disabled={!status}
          >
            {t('next-step')}
          </MyButton>
        </div>
      </div>
    </div>
  )
}

export default StatusSelection
